export default {
  name: "module-name",
  props: {
    name: {
      type: String,
      default: () => ""
    }
  }
};